import { connect } from 'react-redux';
import React, { Component } from 'react';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import { LinkContainer } from 'react-router-bootstrap';
import { Glyphicon, Nav, Navbar, NavItem, NavDropdown, Col, Grid, Row, Button } from 'react-bootstrap';
import LogoIcyteg from '../Images/Logo.png';
import LogoWhatsApp from '../Images/WhatsApp.png';
import ReactGA from 'react-ga';
import '../css/Global.min.css';
import '../css/MenuPrincipal.css';
import PopUp from './PopUp';


class MenuFinal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            LogoMicro: false,
            Actual: ''
        }

        this.faceb = this.faceb.bind(this);
        this.mostrarPopup = React.createRef();
        this.mostrarPrivacidad = this.mostrarPrivacidad.bind(this);
        this.mostrarModelo = this.mostrarModelo.bind(this);
    }

    mostrarPrivacidad() {
        this.mostrarPopup.current.mostrar(9);
    }

    mostrarModelo() {
        this.mostrarPopup.current.mostrar(6);

    }

    componentDidMount() {
        document.getElementById("Face").setAttribute("data-href", window.location.href);
        this.faceb(document, 'script', 'facebook-jssdk');
        ReactGA.initialize('UA-45942649-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
            this.state.Actual = window.location.href;
    }

    componentDidUpdate() {
        if (this.state.Actual != window.location.href) {
            this.state.Actual = window.location.href;
            document.getElementById("Face").setAttribute("data-href", window.location.href);
            ReactGA.pageview(window.location.pathname + window.location.search);
            window.scrollTo(0, 0);
        };
    }



    faceb(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        //js.src = "//connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v2.5";
        js.src = "//connect.facebook.net/es_ES/all.js#xfbml=1";
        fjs.parentNode.insertBefore(js, fjs);
    }
    render() {
        return (
            <div>
                <div className="DivFinal">
                <div>
                    <h4>Nuestro Instituto</h4>
                    <p><a href=''>Quienes somos</a></p>
                        <p><a onClick={this.mostrarModelo} style={{cursor: "pointer"}}>Modelo Educativo</a></p>
                    <p><a href=''>Bolsa de Trabajo</a></p>
                        <p><a onClick={this.mostrarPrivacidad} style={{ cursor: "pointer" }}>Pol&iacute;tica de Privacidad</a></p>
                </div>
                <div>
                    <h4>Atención al alumno</h4>
                        <p>Tel&eacute;fono:<a href='tel:462-6255712'> (462) 6255712</a></p>
                    <p>Correo electr&oacute;nico:<a href='mailto:servicios@icyteg.edu.mx'> servicios@icyteg.edu.mx</a></p>
                </div>
                <div>
                    <h4>Soporte T&eacute;cnico</h4>
                        <p>Tel&eacute;fono:<a href='tel:462-6258898'> (462) 6258898</a></p>
                    <p>Correo electr&oacute;nico:<a href='mailto:soporte@icyteg.edu.mx'> soporte@icyteg.edu.mx</a></p>
                </div>
                <div>
                    <h4>Admisiones</h4>
                        <p>Tel&eacute;fono:<a href='tel:462-6255713'> (462) 6255713</a></p>
                    <p>Correo electr&oacute;nico:<a href='mailto:admisiones@icyteg.edu.mx'> admisiones@icyteg.edu.mx</a></p>
                </div>
                <div>
                    <h4>Redes Sociales</h4>
                        <p>WhatsApp: +52 (462)2336965 </p>
                    <MobileView>
                            <p> <a href='https://wa.me/5214622336965' target='_blank'><img src={LogoWhatsApp} alt='llamar WhatsApp' style={{ width: "30px" }} /> Enviar mensaje ahora</a></p>
                    </MobileView>
                    <p>Facebook:<a href='https://www.facebook.com/icyteg.ac' target='_blank'> https://www.facebook.com/icyteg.ac</a></p>
                    <div id="fb-root" ></div>
                    <div data-href="http://www.icyteg.edu.mx" data-layout="button" data-share="true" class="fb-like" id="Face"  >

                    </div>
                </div>


            </div>
                <PopUp ref={this.mostrarPopup} />
            </div>
            );
    }
}
export default MenuFinal;


// WEBPACK FOOTER //
// ./src/components/MenuFinal.js